function normalizeMonthToken(value = "") {
  return String(value)
    .trim()
    .replace(/\.$/, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
}

function buildMonthMap(locale) {
  const map = new Map();

  for (let monthIndex = 0; monthIndex < 12; monthIndex += 1) {
    const date = new Date(Date.UTC(2024, monthIndex, 1));
    const shortMonth = new Intl.DateTimeFormat(locale, {
      month: "short",
      timeZone: "UTC",
    }).format(date);
    const longMonth = new Intl.DateTimeFormat(locale, {
      month: "long",
      timeZone: "UTC",
    }).format(date);

    map.set(normalizeMonthToken(shortMonth), monthIndex);
    map.set(normalizeMonthToken(longMonth), monthIndex);
  }

  return map;
}

export function formatLocalizedDayMonthYear(value, locale = "en-GB") {
  let date = value instanceof Date ? value : null;
  if (!date && /^\d{4}-\d{2}-\d{2}$/.test(String(value || ""))) {
    const [year, month, day] = String(value).split("-").map(Number);
    date = new Date(year, month - 1, day);
  }
  if (!date) date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const parts = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).formatToParts(date);

  const day = parts.find((part) => part.type === "day")?.value || "";
  const month = parts.find((part) => part.type === "month")?.value || "";
  const year = parts.find((part) => part.type === "year")?.value || "";

  if (!day || !month || !year) return "";
  return `${String(day).padStart(2, "0")} ${month.replace(/\.$/, "").toUpperCase()}, ${year}`;
}

export function parseLocalizedDayMonthYear(value, locale = "en-GB") {
  const match = String(value || "")
    .trim()
    .match(/^(\d{1,2})\s+([^\d,]+)\,?\s+(\d{4})$/);

  if (!match) return "";

  const [, dayText, monthText, yearText] = match;
  const normalizedMonth = normalizeMonthToken(monthText);
  const languageTag = String(locale || "en-GB").trim();
  const shortTag = languageTag.split("-")[0] || "en";
  const locales = Array.from(new Set([languageTag, shortTag, "en-GB", "en-US"]));

  let monthIndex = -1;
  for (const candidate of locales) {
    monthIndex = buildMonthMap(candidate).get(normalizedMonth);
    if (Number.isInteger(monthIndex)) break;
  }

  if (!Number.isInteger(monthIndex) || monthIndex < 0) return "";

  const year = Number(yearText);
  const day = Number(dayText);
  const date = new Date(year, monthIndex, day);

  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() !== monthIndex ||
    date.getDate() !== day
  ) {
    return "";
  }

  return `${yearText}-${String(monthIndex + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
